import Container from "../../../../components/container";
import { PhysicalAndMentalSymptom } from "../../../../models";
import { PhysicalAndMentalSymptomViewModel } from "../../../../viewModels";
import { DeleteChildButton } from "./child-buttons";
import { useState } from "react";
import UpdateChildForm from "./update-child-form";
import CreateChildForm from "./create-child-form";
import { PencilSquareIcon } from "@heroicons/react/24/outline";
import IconButton from "../../../../components/icon-button";

export default function ChildrenSymptomsTable({parent}:{parent:PhysicalAndMentalSymptomViewModel}){
  const [editing,setEditing] = useState<PhysicalAndMentalSymptom>();
     return (
           <Container className="max-w-xl  text-left">
             <table className="min-w-full text-gray-900 text-left ">
               <thead className="rounded-lg text-left text-sm font-normal">
                 <tr>
                   <th scope="col" className="px-6 py-3">
                     Symptom
                   </th>
       
                   <th scope="col" className="px-6 py-3">
                     <span className="sr-only">Edit</span>
                   </th>
                 </tr>
               </thead>
               <tbody className="bg-white">
                 {parent.children?.map((item) => (
                   <tr key={item.id} className="w-full text-left border-b py-3 text-sm last-of-type:border-none [&:first-child>td:first-child]:rounded-tl-lg [&:first-child>td:last-child]:rounded-tr-lg [&:last-child>td:first-child]:rounded-bl-lg [&:last-child>td:last-child]:rounded-br-lg"> 
                     {editing?.id === item.id ? <UpdateChildForm item={item} onCancel={() => setEditing(undefined)} /> : <>
                     
                     <td className="whitespace-nowrap px-6 py-3">{item.name}</td>       
                     <td className="px-6 py-4">
                        {item.id ? (
                          <div className="flex flex-1 items-center justify-end gap-2">
                           <IconButton label="Edit" icon={PencilSquareIcon} onClick={() => setEditing(item)}></IconButton>
                           <DeleteChildButton item={item} />
                         </div>
                       ) : null} 
                     </td>
                     </>}
                   </tr>
                 ))}
               </tbody>
               <tfoot>
                <tr>
                  <td colSpan={2}  className="px-6 py-4">
                    <CreateChildForm parent={parent}></CreateChildForm>
                  </td>
                </tr>
               </tfoot>
             </table>
           </Container>
         );
       }
